:host {
  --prism-text-word-spacing: inherit;
  --prism-text-line-height: inherit;
  --prism-text-spacing-padding: 0;
  --prism-text-spacing-margin: 0;
  --prism-text-max-width: auto;
  --prism-text-transform: inherit;
  color: inherit;
  display: var(--prism-text-display);
}

:host(.text-block) {
  --prism-text-display: block;
}

.text {
  margin: var(--prism-text-spacing-margin);
  padding: var(--prism-text-spacing-padding);
  display: var(--prism-text-display);
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: var(--prism-text-line-height);
  word-spacing: var(--prism-text-word-spacing);
  text-transform: var(--prism-text-transform);
  text-decoration-line: inherit;
}
/** Display Family **/
.display-100 {
  font-size: var(--prism-font-display-100-size);
  font-family: var(--prism-font-display-100-family);
  line-height: var(--prism-font-display-100-leading);
  font-weight: var(--prism-font-display-100-weight);
  letter-spacing: var(--prism-font-display-100-tracking);
}

.display-200 {
  font-size: var(--prism-font-display-200-size);
  font-family: var(--prism-font-display-200-family);
  line-height: var(--prism-font-display-200-leading);
  font-weight: var(--prism-font-display-200-weight);
  letter-spacing: var(--prism-font-display-200-tracking);
}

.display-300 {
  font-size: var(--prism-font-display-300-size);
  font-family: var(--prism-font-display-300-family);
  line-height: var(--prism-font-display-300-leading);
  font-weight: var(--prism-font-display-300-weight);
  letter-spacing: var(--prism-font-display-300-tracking);
}
/** Heading Family **/
.headline-100 {
  font-size: var(--prism-font-headline-100-size);
  font-family: var(--prism-font-headline-100-family);
  line-height: var(--prism-font-headline-100-leading);
  font-weight: var(--prism-font-headline-100-weight);
  letter-spacing: var(--prism-font-headline-100-tracking);
}

.headline-200 {
  font-size: var(--prism-font-headline-200-size);
  font-family: var(--prism-font-headline-200-family);
  line-height: var(--prism-font-headline-200-leading);
  font-weight: var(--prism-font-headline-200-weight);
  letter-spacing: var(--prism-font-headline-200-tracking);
}

.headline-300 {
  font-size: var(--prism-font-headline-300-size);
  font-family: var(--prism-font-headline-300-family);
  line-height: var(--prism-font-headline-300-leading);
  font-weight: var(--prism-font-headline-300-weight);
  letter-spacing: var(--prism-font-headline-300-tracking);
}
/** Body Family **/
.body-100 {
  font-size: var(--prism-font-body-100-size);
  font-family: var(--prism-font-body-100-family);
  line-height: var(--prism-font-body-100-leading);
  font-weight: var(--prism-font-body-100-weight);
  letter-spacing: var(--prism-font-body-100-tracking);
}

.body-200 {
  font-size: var(--prism-font-body-200-size);
  font-family: var(--prism-font-body-200-family);
  line-height: var(--prism-font-body-200-leading);
  font-weight: var(--prism-font-body-200-weight);
  letter-spacing: var(--prism-font-body-200-tracking);
}

.body-300 {
  font-size: var(--prism-font-body-300-size);
  font-family: var(--prism-font-body-300-family);
  line-height: var(--prism-font-body-300-leading);
  font-weight: var(--prism-font-body-300-weight);
  letter-spacing: var(--prism-font-body-300-tracking);
}

.body-400 {
  font-size: var(--prism-font-body-400-size);
  font-family: var(--prism-font-body-400-family);
  line-height: var(--prism-font-body-400-leading);
  font-weight: var(--prism-font-body-400-weight);
  letter-spacing: var(--prism-font-body-400-tracking);
}

.body-500 {
  font-size: var(--prism-font-body-500-size);
  font-family: var(--prism-font-body-500-family);
  line-height: var(--prism-font-body-500-leading);
  font-weight: var(--prism-font-body-500-weight);
  letter-spacing: var(--prism-font-body-500-tracking);
}
/** Buttons **/
.button-sm {
  font-size: var(--prism-font-button-sm-size);
  font-family: var(--prism-font-button-sm-family);
  line-height: var(--prism-font-button-sm-leading);
  font-weight: var(--prism-font-button-sm-weight);
  letter-spacing: var(--prism-font-button-sm-tracking);
  text-transform: var(--prism-font-button-sm-transform);
}

.button-md {
  font-size: var(--prism-font-button-md-size);
  font-family: var(--prism-font-button-md-family);
  line-height: var(--prism-font-button-md-leading);
  font-weight: var(--prism-font-button-md-weight);
  letter-spacing: var(--prism-font-button-md-tracking);
  text-transform: var(--prism-font-button-md-transform);
}
/** Callouts **/
.callout-sm {
  font-size: var(--prism-font-callout-sm-size);
  font-family: var(--prism-font-callout-sm-family);
  line-height: var(--prism-font-callout-sm-leading);
  font-weight: var(--prism-font-callout-sm-weight);
  letter-spacing: var(--prism-font-callout-sm-tracking);
  text-transform: var(--prism-font-callout-sm-transform);
}

.callout-md {
  font-size: var(--prism-font-callout-md-size);
  font-family: var(--prism-font-callout-md-family);
  line-height: var(--prism-font-callout-md-leading);
  font-weight: var(--prism-font-callout-md-weight);
  letter-spacing: var(--prism-font-callout-md-tracking);
  text-transform: var(--prism-font-callout-md-transform);
}
/* Others */
.caption {
  font-size: var(--prism-font-caption-base-size);
  font-family: var(--prism-font-caption-base-family);
  line-height: var(--prism-font-caption-base-leading);
  font-weight: var(--prism-font-caption-base-weight);
  letter-spacing: var(--prism-font-caption-base-tracking);
}

.tag {
  font-size: var(--prism-font-tag-base-size);
  font-family: var(--prism-font-tag-base-family);
  line-height: var(--prism-font-tag-base-leading);
  font-weight: var(--prism-font-tag-base-weight);
  letter-spacing: var(--prism-font-tag-base-tracking);
}

.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  /* For this to work, block is required */
  display: block;
  line-height: 1.1;
  max-width: var(--prism-text-max-width);
}
/* Priority */
.secondary {
  opacity: var(--prism-text-priority, var(--prism-alpha-secondary));
}

.inactive {
  opacity: var(--prism-text-priority, var(--prism-alpha-disabled));
}

.tertiary {
  opacity: var(--prism-text-priority, var(--prism-alpha-tertiary));
}
/** expressive  */
.expressive {
  background-image: var(--prism-color-gradient-linear-brand-primary);
  @apply bg-clip-text text-transparent decoration-clone;
  box-decoration-break: clone;
}
